export enum TypeConsigne {
    Classique = 'Envoyé par un utilisateur',
    RQTH = 'RQTH' ,
    SST = 'SST',
    Habilitation = 'Habilitation',
    Amenagement = 'Amenagement',
    TacheEntreprise = 'Tache en entreprise'   
  }